import { Injectable, inject, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class OrderListStateService {
  readonly #router = inject(Router);

  readonly searchValue = signal('');
  readonly widgetStatus = signal('');
  readonly pageNumber = signal(1);
  readonly pageSize = signal(10);

  constructor() {
    this.#router.events.pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd)).subscribe((e) => {
      const url = e.urlAfterRedirects.split('?')[0];
      if (!this.#isOrdersSection(url)) this.reset();
    });
  }

  #isOrdersSection(url: string): boolean {
    if (url === '/orders') return true;
    return url.startsWith('/orders/') && url !== '/orders/create-order';
  }

  reset(): void {
    this.searchValue.set('');
    this.widgetStatus.set('');
    this.pageNumber.set(1);
    this.pageSize.set(7);
  }
}
